/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { AuthService } from 'src/app/service/auth.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { NewsletterApiService } from 'src/app/shared/services/customer-api/newsletter-api.service';
import { Observable } from 'rxjs';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PortfolioShareComponent } from '../portfolio-share/portfolio-share.component';

@Component({
  selector: 'app-portfolio-name',
  templateUrl: './portfolio-name.component.html',
  styleUrls: ['./portfolio-name.component.scss'],
})
export class PortfolioNameComponent {
  namefolio: UntypedFormControl;
  $newsletter: Observable<any>;
  idelete = 0;
  newsletterTitle = '';
  portfoliosList = [];
  selectedPortfolios = [];
  portfolioType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public snackBar: MatSnackBar,
    private router: Router,
    public routing: RoutingService,
    public auth: AuthService,
    public portfolioApi: PortfolioApiService,
    private newsletterApi: NewsletterApiService,
  ) {
    this.portfolioType = 'regular';

    if (
      this.data &&
      this.data.entity &&
      !this.data.entity.compound_key &&
      this.data.entity.type &&
      this.data.entity.alpha_id
    ) {
      this.data.entity.compound_key =
        this.data.entity.type + ':' + this.data.entity.alpha_id;
    }

    if (this.data.action === 'add') {
      this.portfolioApi.portFolios().subscribe((portfolios: any[]) => {
        this.portfoliosList = portfolios.filter(
          (portfolio: any) =>
            portfolio.sharing_mode !== 'read' && !portfolio.is_aggregated,
        );
      });
    }

    this.namefolio = new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]);
    if (this.data.action === 'edit') {
      this.namefolio.setValue(this.portfolioApi.activePortfolio.name);
    }
  }

  iSave() {
    if (this.namefolio.valid) {
      if (this.data.action === 'edit') {
        this.portfolioApi
          .renamePortfolio(this.namefolio.value)
          .subscribe(() => {
            this.dialog.closeAll();
            this.router.navigate([], {
              queryParams: {
                update: Math.random(),
              },
              queryParamsHandling: 'merge',
            });
          });
      }
      if (this.data.action === 'new') {
        if (
          this.portfolioApi.portfolios &&
          this.portfolioApi.portfolios.length + 1 >
            this.auth.featureFlags.portfoliosLimit
        ) {
          this.snackBar.open(
            'Number of portfolios is limited to ' +
              this.auth.featureFlags.portfoliosLimit +
              '.',
            'OK',
            { duration: 5000 },
          );
        } else {
          this.portfolioApi
            .newFolio(this.namefolio.value, this.portfolioType)
            .subscribe((newPortfolio) => {
              this.dialog.closeAll();
              this.router.navigate([], {
                queryParams: {
                  id: newPortfolio.id,
                  update: Math.random(),
                },
                queryParamsHandling: 'merge',
              });
            });
        }
      }
    }
  }

  delete() {
    this.portfolioApi.deletePortfolio().subscribe(() => {
      this.dialog.closeAll();
      this.router.navigate([], {
        queryParams: {
          id: null,
        },
        queryParamsHandling: 'merge',
      });
    });
  }

  iDelete() {
    this.$newsletter = this.newsletterApi.allNewsletter();
    this.$newsletter.subscribe((newsletters: any[]) => {
      const activePortfolioUid = this.portfolioApi.activePortfolio.uid;
      const linkedNewsletters = newsletters.filter((newsletter: any) =>
        newsletter.displayables.some((displayable: string) => {
          const [, , type, uid] = displayable.split(':');
          return type === 'portfolio' && uid === activePortfolioUid;
        }),
      );
      if (linkedNewsletters.length > 0) {
        this.idelete = 1;
        this.newsletterTitle = '"' + linkedNewsletters[0].title + '"';
      } else {
        this.delete();
        this.idelete = 0;
      }
    });
  }

  /**
   * share portfolio with other users
   */
  iShare() {
    if (!this.portfolioApi.activePortfolio.sharing_mode) {
      this.dialog.open(PortfolioShareComponent, {
        data: {
          // uid: this.params.folio,
        },
      });
    }
  }

  /**
   * create portfolio with provided entity
   */
  iCreate(openPortfolio) {
    if (this.namefolio.valid) {
      if (
        this.portfolioApi.portfolios &&
        this.portfolioApi.portfolios.length + 1 >
          this.auth.featureFlags.portfoliosLimit
      ) {
        this.snackBar.open(
          'Number of portfolios is limited to ' +
            this.auth.featureFlags.portfoliosLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
      } else {
        this.portfolioApi
          .newFolio(this.namefolio.value)
          .subscribe((newPortfolio) => {
            this.portfolioApi
              .addEntitiesToPortfolios(
                [this.data.entity.compound_key],
                [newPortfolio.id],
              )
              .subscribe(() => {
                this.dialog.closeAll();
                this.snackBar.open(
                  'Portfolio ' + this.namefolio.value + ' created.',
                  'OK',
                  { duration: 5000 },
                );
                if (openPortfolio) {
                  this.router.navigate(['/cockpit/news/portfolio'], {
                    queryParams: {
                      id: newPortfolio.id,
                      update: Math.random(),
                    },
                    queryParamsHandling: 'merge',
                  });
                }
              });
          });
      }
    }
  }

  /**
   * add entity to selected portfolios
   */
  iAdd(openPortfolio) {
    if (this.selectedPortfolios.length === 0) {
      return;
    }
    const entitiesPerPortfolioLimit =
      this.auth.featureFlags.entitiesPerPortfoliosLimit;
    const exceedsLimit = this.portfoliosList.some(
      (portfolio: any) =>
        this.selectedPortfolios.includes(portfolio.uid) &&
        portfolio.content.length + 1 > entitiesPerPortfolioLimit,
    );
    if (exceedsLimit) {
      this.snackBar.open(
        'Number of entities per portfolio is limited to ' +
          entitiesPerPortfolioLimit +
          '.',
        'OK',
        { duration: 5000 },
      );
      return;
    }
    this.portfolioApi
      .addEntitiesToPortfolios(
        [this.data.entity.compound_key],
        this.selectedPortfolios,
      )
      .subscribe(() => {
        this.dialog.closeAll();
        this.snackBar.open('Entity added to selected portfolios.', 'OK', {
          duration: 5000,
        });
        if (openPortfolio && this.selectedPortfolios.length === 1) {
          this.router.navigate(['/cockpit/news/portfolio'], {
            queryParams: {
              id: this.selectedPortfolios[0],
              update: Math.random(),
            },
            queryParamsHandling: 'merge',
          });
        }
      });
  }
}
